import { TableContainer } from "../../../styles";
import { Parte } from "../../../types";
import { Check, X } from "lucide-react";

interface CardParteProcessoProps {
    parte: Parte;
}

export default function CardParteProcesso({ parte }: CardParteProcessoProps) {
    return (
        <TableContainer>
            <div className="parte-header">PARTES DO PROCESSO</div>
            <table className="data-table">
                <thead>
                    <tr>
                        <th className="field-col">Campo</th>
                        <th className="value-col">Valor</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td className="field-cell">Tipo</td>
                        <td className="value-cell">{parte.tipo}</td>
                    </tr>
                    <tr className="border-top">
                        <td className="field-cell">Nome</td>
                        <td className="value-cell">{parte.nome}</td>
                    </tr>
                    <tr className="border-top">
                        <td className="field-cell">Parte Representada</td>
                        <td className="value-cell">
                            {parte.representada ? (
                                <Check className="check-icon" />
                            ) : (
                                <X className="x-icon" />
                            )}
                        </td>
                    </tr>
                </tbody>
            </table>
        </TableContainer>
    );
}
